export default "__VITE_ASSET__FmNdGXQY__"